import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { AccordionSummary, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";

export function ProductPassportAccordionHeader({ title, onClick }) {
    return (
        <AccordionSummary
            expandIcon={
                <ExpandMoreIcon
                    sx={{
                        "&:hover": {
                            backgroundColor: grey[200],
                            borderRadius: 999,
                        },
                    }}
                />
            }
            sx={{ height: 0 }}
            onClick={onClick}
        >
            <Typography variant="h6">{title}</Typography>
        </AccordionSummary>
    );
}
